import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export default function Verify() {
  const { tid } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/verify/${tid}`)
      .then((r) => r.ok ? r.json() : Promise.reject(r))
      .then(setData)
      .catch(() => setErr("Transmission not found or invalid."));
  }, [tid]);

  return (
    <div className="min-h-screen bg-[#03040B] text-white grid-bg p-8 lg:p-16">
      <div className="max-w-3xl mx-auto" data-testid="verify-page">
        <div className="label-overline">Public Certificate Verification</div>
        <h1 className="font-display font-black text-4xl tracking-tighter mt-2">Transmission Verification</h1>

        {err && <div className="mt-8 text-[#FF3366] font-mono-data" data-testid="verify-error">{err}</div>}

        {data && (
          <div className="mt-8 holo-panel p-8 space-y-4" data-testid="verify-card">
            {[
              ["Transmission ID", data.transmission_id],
              ["Mission Number", data.mission_number],
              ["Capsule", data.capsule_name],
              ["Status", data.status.replace(/_/g, " ")],
              ["Package Size", data.package_size + " B"],
              ["Started", data.started_at],
              ["Completed", data.completed_at || "—"],
              ["SHA-512 Hash", data.digital_hash],
              ["Signature", data.digital_signature],
            ].map(([k, v]) => (
              <div key={k}>
                <div className="label-overline">{k}</div>
                <div className="font-mono-data text-sm mt-1 break-all">{v}</div>
              </div>
            ))}
            <div className="divider-cyan" />
            <div className="font-mono-data text-[11px] tracking-[0.2em] uppercase text-[#00FFAA]">VERIFIED ✓</div>
          </div>
        )}
      </div>
    </div>
  );
}
